<script setup>
import AddrSelect from "../../lib/components/AddrSelect.vue";
import SetupDialog from "../components/SetupDialog.vue";
import { useRouter } from "vue-router";
import { useHttp } from "vutil";
import { ref } from "vue";

const props = defineProps(["id"]);

const setup = ref();
const router = useRouter();
const { data: site, error: getError, get } = useHttp();
const { busy, error: saveError, post, put, del } = useHttp(data =>
{
	if (data && !history.state.site)
		setup.value = { ...data, url: `wss://ocpp.zev.no:6420/ocpp/${data.id}/{deviceId}` };
	else
		router.push({ name: 'home' });
});
const { get: getAddr } = useHttp(data =>
{
	if (data.adresser.length !== 1)
		return getLocation();

	const [ addr ] = data.adresser;

	setSite({
		addr: addr.adressetekst,
		zip:  addr.postnummer,
		city: addr.poststed,
		lat:  addr.representasjonspunkt.lat,
		lng:  addr.representasjonspunkt.lon
	});
}, () => getLocation());

function setSite(value)
{
	if (history.state.site) {
		value.name = history.state.site.name;
		value.vendor = history.state.site.vendor;
		value.ref = history.state.site.ref;
	}

	site.value = value;
}

function getLocation()
{
	navigator.geolocation.getCurrentPosition(({ coords }) => {
		setSite({ lng: coords.longitude, lat: coords.latitude });
	}, () => {
		setSite({ lng: 9.794254, lat: 61.077207 });
	});
}

if (props.id.length)
	get(`/api/site/${props.id}`);
else if (history.state.site && history.state.site.addr)
	getAddr("https://ws.geonorge.no/adresser/v1/sok?sok=" + encodeURIComponent(history.state.site.addr));
else
	getLocation();
</script>

<template>
	<div v-if="getError" class="error">{{ getError }}</div>
	<div v-else-if="!site" class="busy"/>
	<form v-else class="site" @submit.prevent="id.length ? put(`/api/site/${id}`, site) : post('/api/site', site)">
		<fieldset :disabled="busy">
			<label for="name">Navn</label>
			<input id="name" v-model.trim="site.name" type="text" placeholder="Lars Hansen eller Hansen AS" required>
			<div class="ui-hint">Navn på stedets juridiske eier</div>
			<label for="orgnr">Organisasjonsnummer</label>
			<input id="orgnr" v-model="site.orgnr" v-valid-orgnr type="text">
			<div class="ui-hint">Fylles kun ut for bedrifter</div>
			<label for="price_el">Ladepris</label>
			<input id="price_el" v-model.number="site.price_el" type="number" min="1" max="5000" placeholder="123" required>
			<div class="ui-hint">Fast pris i øre/kWh eks. mva</div>
			<label for="price_park">Parkeringspris</label>
			<input id="price_park" v-model.number="site.price_park" type="number" min="0" max="50000" placeholder="2000" required>
			<div class="ui-hint">Pris i øre/time eks. mva</div>
			<label for="accnr">Bankkonto</label>
			<input id="accnr" v-model="site.accnr" v-valid-accnr type="text" required>
			<div class="ui-hint">Kontonummer for utbetaling av ladeinntekter</div>
			<label for="addr">Stedsadresse</label>
			<AddrSelect id="addr" v-model:addr="site.addr" v-model:zip="site.zip" v-model:city="site.city"
				v-model:lat="site.lat" v-model:lng="site.lng" :nearby="!site.addr"/>
			<div class="error">{{ saveError }}</div>
			<div class="btn-row">
				<button type="submit" class="ui">Lagre</button>
				<button v-if="id.length" type="button" class="ui outlined" @click="del(`/api/site/${id}`)">Slett</button>
				<button v-if="id.length" type="button" class="ui outlined" @click="post(`/api/site/${id}/passwd`)">Nytt lader passord</button>
			</div>
			<VmapMap :center="[site.lng, site.lat]" :zoom="17">
				<VmapMarker v-model:lat="site.lat" v-model:lng="site.lng" draggable>
					<img class="icon-charging-station-free"/>
				</VmapMarker>
			</VmapMap>
		</fieldset>
	</form>
	<SetupDialog v-if="setup" :setup="setup" @confirm="$router.push({ name: 'home' })"/>
</template>
